const wrapperCls = "c2lw43b59a";
const iframeCls = "c2li1dn0s6b";
const headingCls = "c2lhkzkius";
const bodyCls = "c2lb1ye4sjl";
const buttonCls = "c2lb2yf5br";

export { bodyCls, buttonCls, headingCls, iframeCls, wrapperCls };
import "./empty.style.linaria.module.css";
//# sourceMappingURL=empty.style.js.map
